<p-tabs [value]="activeTab" [lazy]="true" (valueChange)="onTabChange($event)">
    <div class="flex items-center gap-4">
        <div class="flex-auto">
            <p-tablist class="overflow-hidden">
                <p-tab [value]="0">Ebay</p-tab>
                <p-tab [value]="1" disabled>Webshop</p-tab>
            </p-tablist>
        </div>
        @if(product.produits_ebay && product.produits_ebay.length > 0) {
            <div class="flex-none">
                <p-button label="Réactualisation stocks" pTooltip="Réactualisation des stocks vers le stock Ebay" icon="pi pi-refresh" severity="info" [disabled]="isRefreshingData" [loading]="isRefreshingData" (click)="refreshEbayStocks()" />
            </div>
        }
    </div>
    <p-tabpanels class="block !p-0">
        <p-tabpanel [value]="0">
            <app-product-detail-distribution-ebay [(product)]="product" [tabIndex]="0" [(tabStates)]="subTabStates" (needStockReload)="onNeedStockTabReload()"></app-product-detail-distribution-ebay>
        </p-tabpanel>
        <p-tabpanel [value]="1">
            <app-product-detail-distribution-webshop></app-product-detail-distribution-webshop>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>

